<template>
  <div class="auth-layout">
    <div class="auth-layout__left-col">
      <div class="white-logo">
        <img :src="require('@/assets/white-logo.svg')" alt="" />
      </div>
    </div>
    <div class="auth-layout__right-col">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useTheme } from 'vuetify';

// Vuetify
const theme = useTheme();

// Lifecycle
onBeforeMount(() => {
  theme.change('light');
});
</script>

<style lang="scss" scoped>
.auth-layout {
  position: relative;
  min-height: 100vh;
  padding: 80px 80px 80px 60px;
  display: flex;
  background: var(--theme-bg-page);

  &__left-col {
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 5%;
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    height: 100%;
    position: sticky;
    top: 50px;
  }

  &__right-col {
    width: 67.7%;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media only screen and (max-width: 767px) {
    padding: 40px;
    flex-wrap: wrap;
    &__left-col {
      width: 100%;
      padding-right: 0;
      position: relative;
      top: auto;
      .white-logo {
        margin-bottom: 30px;
      }
    }
    &__right-col {
      width: 100%;
    }
  }
  @media only screen and (max-width: 580px) {
    padding: 15px;
  }
}
</style>
